var map = {
	"./1.JPG": 9089,
	"./2.JPG": 6198,
	"./3.JPG": 9843,
	"./4.JPG": 7936,
	"./5.JPG": 8781,
	"./6.JPG": 4034,
	"./7.JPG": 687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8384;